import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-db6d8de8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "library" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = {
  key: 0,
  class: "card-body"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Building blocks", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "card-text" }, "You can add building blocks to the flow by dragging them from this panel to the desired place in the flow.", -1))
const _hoisted_6 = { class: "mx-3" }
const _hoisted_7 = { class: "input-group mb-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "input-group-text",
  id: "basic-addon1"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-fw fa-magnifying-glass" }),
  /*#__PURE__*/_createTextVNode(" ")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times" }, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "library-content" }
const _hoisted_13 = { class: "card-subtitle text-muted" }
const _hoisted_14 = ["onMousedown"]
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.ready)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  placeholder: "Search",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                  "aria-label": "Search",
                  "aria-describedby": "basic-addon1"
                }, null, 512), [
                  [_vModelText, _ctx.search]
                ]),
                (_ctx.search)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.search = '')),
                      class: "input-group-text cursor-pointer d-flex flex-row align-items-center pe-2",
                      id: "basic-addon1"
                    }, _hoisted_11))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredObjects, (objects, category) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: category,
                  class: _normalizeClass(['object-category', category])
                }, [
                  _createElementVNode("h6", _hoisted_13, _toDisplayString(category), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(objects, (objectType, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: idx,
                      class: _normalizeClass(['object-type', objectType.category, objectType.available === false ? 'not-available' : '']),
                      onMousedown: _withModifiers(($event: any) => (_ctx.$emit('object-mouse-down', { event: $event, objectType })), ["stop","prevent"])
                    }, [
                      _createElementVNode("img", {
                        src: _ctx.vm.getIconUrl(objectType.icon),
                        class: "darkmode-invert"
                      }, null, 8, _hoisted_15),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(objectType.title), 1),
                      _createElementVNode("span", {
                        class: _normalizeClass(["overlay", [objectType.subCategory, objectType.subCategory ? 'custom' : '']])
                      }, null, 2),
                      _createElementVNode("span", {
                        class: _normalizeClass(['category-circle', objectType.category])
                      }, null, 2)
                    ], 42, _hoisted_14))
                  }), 128))
                ], 2))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}